import { apiCall } from "../utils/ApiUtils";
import { getSession, getSessionJSON, setSession, setSessionJSON } from "../utils/SessionUtils";

export const findAllContext = async () => {
  const adminURL = process.env.REACT_APP_ADMIN_BASE_URL;
  const url = `${adminURL}/context/findAllContext`;
  try {
    const response = await apiCall("GET", url);
    console.log("User findAllContext response:", response);
    return response;
  } catch (error) {
    throw new Error("Invalid context request");
  }
};

/** Loads tenant contexts after auth; uses session cache when present. */
export const ensureContextLoaded = async () => {
  const cached = getSessionJSON("CONTEXTS");
  if (cached && cached.length > 0) {
    return cached;
  }
  const context = await findAllContext();
  const companyValue = context[0].companyCode;
  setSession("COMPANY", companyValue);
  setSessionJSON("CONTEXTS", context);
  return context;
};
